<template>
  <v-container class="mt-4 ml-2" fluid>

    <!-- Nueva Tabla: Documentos de Procesos (Jefes de Depto) -->
    <v-row class="mt-6" v-if="puestos.includes(getdatosUsuarioERPERP.idpuesto)">
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-0">
            <span class="text-subtitle-1">Documentos de Procesos (Jefes de Depto.)</span>
            <v-spacer></v-spacer>

            <v-btn color="primary" dark class="text-capitalize mr-2" @click="crearDocumento()" small tile>
              <v-icon left small>mdi-plus</v-icon>
              Subir Documento
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table :headers="headersDocumentos" :items="documentosFiltrados" :search="search"
              class="elevation-0" :mobile-breakpoint="100" dense>
              
              <template v-slot:item.archivo_nombre="{ item }">
                <v-btn v-if="item.archivo_nombre" icon small color="primary" @click="descargarDocumento(item)">
                  <v-icon>mdi-file-download</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.validacion_dc="{ item }">
                <v-chip small :color="item.validacion_dc ? 'green' : 'amber'" dark>
                  {{ item.validacion_dc ? 'Validado' : 'Pendiente' }}
                </v-chip>
              </template>

              <template v-slot:item.acciones="{ item }">
                <v-row>
                  <v-btn small icon @click="abrirDialogDocumento(item)" v-if="canEdit">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn v-if="tieneAccesoDoc(item)" small color="red" dark icon @click="eliminarDocumento(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-row>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>

      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title class="pb-0">
            <span class="text-subtitle-1">Validación de Procesos Estandarizados</span>
            <v-spacer></v-spacer>

            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar proceso..." single-line hide-details
              dense class="mr-4" style="max-width: 300px;"></v-text-field>

            <v-btn v-if="puedeEditarPrompt" color="indigo" dark class="text-capitalize mr-2" @click="abrirPrompt()" small tile>
              <v-icon left small>mdi-text-box-outline</v-icon>
              Prompt
            </v-btn>

            <v-btn color="primary" dark class="text-capitalize mr-2" @click="crearProceso()" small tile>
              <v-icon left small>mdi-plus</v-icon>
              Nuevo Proceso
            </v-btn>

            <v-btn color="primary" dark class="text-capitalize" @click="initialize()" small tile>
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Barra de avance y tarjetas -->
            <v-row class="mt-4">
              <v-col cols="12" md="3">
                <v-card outlined class="text-center pa-4" color="grey lighten-4">
                  <v-icon color="primary" size="32" class="mb-2">mdi-chart-donut</v-icon>
                  <div class="text-h4 font-weight-bold primary--text">{{ avancePorcentaje }}%</div>
                  <div class="text-caption">Avance Total</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="green lighten-4">
                  <v-icon color="green" size="32" class="mb-2">mdi-check-circle</v-icon>
                  <div class="text-h4 font-weight-bold green--text">{{ getCompleted.length }}</div>
                  <div class="text-caption">Procesos Completados</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="amber lighten-4">
                  <v-icon color="amber darken-2" size="32" class="mb-2">mdi-clock-alert</v-icon>
                  <div class="text-h4 font-weight-bold amber--text">{{ getReview.length }}</div>
                  <div class="text-caption">Procesos Pendientes</div>
                </v-card>
              </v-col>

              <v-col cols="6" md="3">
                <v-card outlined class="text-center pa-4" color="red lighten-4">
                  <v-icon color="red" size="32" class="mb-2">mdi-close-circle</v-icon>
                  <div class="text-h4 font-weight-bold red--text">{{ getReject.length }}</div>
                  <div class="text-caption">Procesos Rechazados</div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Filtro por departamento -->
            <v-row justify="end" class="mt-4">
              <v-col cols="12" md="4" lg="3">
                <v-select label="Filtrar por departamento" filled dense hide-details :items="departamentos"
                  item-text="departamento" item-value="id" v-model="departamentoFiltro" clearable></v-select>
              </v-col>
            </v-row>

            <!-- Tabla de validación -->
            <v-row class="mt-4">
              <v-col cols="12">
                <v-data-table :headers="headersValidacion" :items="procesosFiltrados" :search="search"
                  class="elevation-0 procesos-table" :mobile-breakpoint="100" dense>
                  <template v-slot:item.index="{ index }">{{ index + 1 }}</template>

                  <template v-slot:item.escuela="{ item }">
                    <v-chip small color="colorinbi" dark v-if="item.escuela == 1">INBI</v-chip>
                    <v-chip small color="colorfast" dark v-else-if="item.escuela == 2">FAST</v-chip>
                    <v-chip small color="grey" dark v-else>—</v-chip>
                  </template>

                  <template v-slot:item.tipo_documentacion="{ item }">
                    <v-chip v-if="item.tipo_documentacion" small :color="item.tipo_documentacion === 'Asistida' ? 'deep-purple' : 'blue'" dark>
                      {{ item.tipo_documentacion }}
                    </v-chip>
                    <span v-else>—</span>
                  </template>

                  <template v-slot:item.fecha_documentacion="{ item }">
                    <span class="text-no-wrap">{{ formatFecha(item.fecha_documentacion) }}</span>
                  </template>

                  <template v-slot:item.quien_asistio="{ item }">
                    <span class="text-no-wrap">{{ item.quien_asistio || '—' }}</span>
                  </template>

                  <template v-slot:item.documentosProceso="{ item }">
                    <div class="d-flex align-center flex-wrap">
                      <v-btn v-if="item.audio_name" icon small :color="item.isPlaying ? 'error' : 'success'"
                        @click="reproducirAudio(item)" class="ml-1" :title="item.isPlaying ? 'Pausar audio' : 'Reproducir audio'">
                        <v-icon>{{ item.isPlaying ? 'mdi-pause' : 'mdi-play' }}</v-icon>
                      </v-btn>
                      <v-btn v-if="item.audio_name" icon small color="primary" @click="descargarAudio(item)" class="ml-1"
                        title="Descargar audio">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="puedeTranscribir(item)" x-small color="primary" class="ml-1 text-capitalize" :loading="transcribiendoId === item.id"
                        @click="transcribirAudio(item)">
                        Transcribir
                      </v-btn>
                      <v-btn v-if="item.transcription" icon small color="indigo" class="ml-1" @click="descargarWord(item)"
                        title="Descargar Word">
                        <v-icon>mdi-file-word</v-icon>
                      </v-btn>
                      <v-btn v-if="getPdfNombre(item, 'archivo')" icon small color="primary" class="ml-1"
                        @click="verPdf(item, 'archivo')" title="Ver PDF del proceso">
                        <v-icon>mdi-file-pdf-box</v-icon>
                      </v-btn>
                      <v-btn v-if="getPdfNombre(item, 'diagrama')" icon small color="secondary" class="ml-1"
                        @click="verPdf(item, 'diagrama')" title="Ver diagrama">
                        <v-icon>mdi-file-tree</v-icon>
                      </v-btn>
                      <v-btn v-if="getPdfNombre(item, 'manual')" icon small color="orange darken-2" class="ml-1"
                        @click="verPdf(item, 'manual')" title="Manual de operación">
                        <v-icon>mdi-book-open-page-variant</v-icon>
                      </v-btn>
                    </div>
                  </template>

                  <template v-slot:item.validacionLider="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.validacion_lider ? 'success' : (canValidarDirector(item) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="item.validacion_lider ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(item, 'lider')"
                    >
                      <v-icon left x-small>{{ item.validacion_lider ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ item.validacion_lider ? 'Valido' : 'Invalido' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.validacionSocio="{ item }">
                    <v-chip
                      small
                      label
                      :color="item.validacion_socio ? 'success' : (canValidarControlInterno(item) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="item.validacion_socio ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(item, 'socio')"
                    >
                      <v-icon left x-small>{{ item.validacion_socio ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ item.validacion_socio ? 'Valido' : 'Invalido' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.estatus="{ item }">
                    <v-btn rounded
                      :color="getColorEstatus(item.estatus, item.estatusKey)"
                      dark
                      x-small depressed @click.prevent>
                      {{ item.estatus }}
                    </v-btn>
                    <!-- <v-chip small :color="getColorEstatus(item.estatus)">
                      {{ item.estatus }}
                    </v-chip> -->
                  </template>

                  <template v-slot:item.acciones="{ item }">
                    <v-btn small icon @click="abrirDialog(item, true)" title="Editar">
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <v-btn v-if="tieneAccesoAlProceso(item)" small color="red" dark icon @click="eliminar(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


    <!-- Dialog para ver/editar proceso por fases -->
    <v-dialog v-model="dialog" max-width="980px" persistent>
      <v-card class="shadowCard">

        <v-card-title primary-title class="pb-0">
          <span class="text-subtitle-1">{{ form.id ? 'Editar proceso' : 'Nuevo proceso' }}</span>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="fase-bar">
          <button type="button" class="fase-item" :class="{ 'fase-item--activa': Number(faseEdicion) === 1, 'fase-item--lista': !!form.titulo }" @click="faseEdicion = 1">
            <span class="fase-num">1</span>
            <span>
              <span class="fase-kicker">Fase 1</span>
              <span class="fase-nombre">Descripción</span>
            </span>
          </button>
          <button type="button" class="fase-item" :class="{ 'fase-item--activa': Number(faseEdicion) === 2, 'fase-item--lista': !!(form.audio_name || transcripcion) }" @click="faseEdicion = 2">
            <span class="fase-num">2</span>
            <span>
              <span class="fase-kicker">Fase 2</span>
              <span class="fase-nombre">Audio y Word</span>
            </span>
          </button>
          <button type="button" class="fase-item" :class="{ 'fase-item--activa': Number(faseEdicion) === 3, 'fase-item--lista': !!(getPdfNombre(form, 'archivo') || getPdfNombre(form, 'diagrama') || getPdfNombre(form, 'manual')) }" @click="faseEdicion = 3">
            <span class="fase-num">3</span>
            <span>
              <span class="fase-kicker">Fase 3</span>
              <span class="fase-nombre">Documentos</span>
            </span>
          </button>
          <button type="button" class="fase-item" :class="{ 'fase-item--activa': Number(faseEdicion) === 4, 'fase-item--lista': !!form.validacion_lider }" @click="faseEdicion = 4">
            <span class="fase-num">4</span>
            <span>
              <span class="fase-kicker">Fase 4</span>
              <span class="fase-nombre">Liberación</span>
            </span>
          </button>
        </div>

        <v-stepper v-model="faseEdicion" non-linear flat class="proceso-stepper elevation-0">

          <v-stepper-items>
            <v-stepper-content step="1">

          <!-- Título del proceso -->
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="form.titulo" label="Título del proceso" :disabled="!modoEdicion" filled
                dense></v-text-field>
            </v-col>
          </v-row>

          <!-- Escuela (INBI / FAST) -->
          <v-row class="mt-2">
            <v-col cols="12">
              <div class="text-caption mb-1">Escuela</div>
              <v-radio-group v-model="form.escuela" :disabled="!modoEdicion" hide-details class="mt-0">
                <v-radio label="INBI" :value="1" color="primary"></v-radio>
                <v-radio label="FAST" :value="2" color="primary"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <!-- Departamento / responsables (mantener igual) -->
          <v-row class="mt-2">
            <!-- JEFE DE DEPARTAMENTO -->
            <v-col cols="6">
              <v-autocomplete v-model="form.id_jefe_departamento" :items="filterJefes" item-text="nombre_completo"
                item-value="id" label="Seleccionar jefe de departamento" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>

            <!-- RESPONSABLE -->
            <v-col cols="6">
              <v-autocomplete v-model="form.id_responsable" :items="filterResponsables" item-text="nombre_completo"
                item-value="id" label="Seleccionar responsable" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete v-model="form.id_departamento" :items="departamentos" item-text="departamento"
                item-value="id" label="Seleccionar departamento" filled dense :disabled="!modoEdicion"
                clearable></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="form.fecha_documentacion" label="Fecha de documentación" type="date" filled dense
                :disabled="!modoEdicion"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select v-model="form.tipo_documentacion" :items="tiposDocumentacion" label="Tipo de documentación"
                filled dense clearable :disabled="!modoEdicion" @change="onTipoDocumentacionChange"></v-select>
            </v-col>
            <v-col cols="6" v-if="form.tipo_documentacion === 'Asistida'">
              <v-select v-model="form.quien_asistio" :items="asistentesDocumentacion" label="Quién asistió" filled dense
                clearable :disabled="!modoEdicion"></v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="form.observacion" label="Descripción / observaciones" :disabled="!modoEdicion" filled dense
                auto-grow rows="3"></v-textarea>
            </v-col>
          </v-row>

            </v-stepper-content>

            <v-stepper-content step="2">
          <!-- === Sección de Audio (grabar / subir → transcripción → Word) === -->
          <v-row>
            <v-col cols="12">
              <v-row v-if="showRecording()" align="center" class="mb-1">
                <div class="text-subtitle-2">
                  Grabación del proceso (audio)
                  <v-btn icon color="pink" x-small @click="mostrarGuia = true">
                    <v-icon small>mdi-microphone-question</v-icon>
                  </v-btn>
                </div>
              </v-row>
              <v-card outlined class="pa-4">
                <v-row align="center" justify="center">
                  <v-col cols="auto" v-if="showRecording() && modoEdicion">
                    <v-btn v-if="!isRecording" text large color="primary" @click="startRecording">
                      <v-icon left large>mdi-microphone</v-icon>
                      Iniciar Grabación
                    </v-btn>
                    <v-btn v-else text large color="error" @click="stopRecording">
                      <v-icon left large>mdi-stop</v-icon>
                      Detener Grabación
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="8" v-if="modoEdicion && showRecording()">
                    <v-file-input
                      v-model="archivoAudio"
                      accept="audio/*,.mp3,.wav,.webm,.ogg,.m4a"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-music"
                      label="O subir archivo de audio"
                      @change="onAudioFileChange"
                    />
                  </v-col>

                  <v-col cols="12" class="text-center mt-2" v-if="audioUrl || form.audioBase64 || form.audio_name">
                    <audio
                      controls
                      :src="audioUrl || getAudioSrc(form.audioBase64) || (form.audio_name ? (URL_AUDIO + form.audio_name) : '')"
                      class="mt-2"
                      style="width: 100%; max-width: 500px;"
                    ></audio>
                  </v-col>

                  <v-col cols="12" class="text-center mt-2 grey--text text--darken-1"
                    v-if="!audioUrl && !form.audioBase64 && !form.audio_name && !isRecording && !archivoAudio">
                    <span v-if="showRecording()">
                      No hay grabación. Graba o sube un audio. La transcripción se hace con el botón Transcribir, después de que el director autorice el proceso, y queda el archivo en Word.
                    </span>
                    <span v-else>
                      Solo el documentador (responsable) puede grabar o subir audio.
                    </span>
                  </v-col>

                  <v-skeleton-loader
                    v-if="showSkeleton"
                    v-bind="attrs"
                    style="width: 50vw"
                    type="list-item-two-line"
                    class="shadow-0"
                  ></v-skeleton-loader>
                </v-row>

                <v-row class="mt-3" justify="center" v-if="modoEdicion && (audioUrl || form.audioBase64 || archivoAudio)">
                  <v-btn text color="error" small @click="clearAudio">
                    <v-icon left small>mdi-delete</v-icon>
                    Eliminar audio actual
                  </v-btn>
                </v-row>

                <v-row class="mt-3" justify="center" v-if="puedeTranscribirForm">
                  <v-btn color="primary" small class="text-capitalize" :loading="transcribiendoId === form.id"
                    @click="transcribirAudio(form)">
                    <v-icon left small>mdi-text-recognition</v-icon>
                    Transcribir
                  </v-btn>
                </v-row>
                <v-row class="mt-2" justify="center" v-else-if="(form.audio_name || audioName) && !transcripcion && form.id">
                  <v-col cols="12" class="text-center grey--text text--darken-1 text-caption">
                    El audio está guardado. El botón Transcribir aparece cuando el director autorice el proceso.
                  </v-col>
                </v-row>

                <v-row class="mt-3" justify="center" v-if="transcripcion">
                  <v-col cols="12" class="text-justify grey--text text--darken-1"
                    style="max-height: 120px; overflow-y: auto;">
                    <div class="text-caption font-weight-medium mb-1">Transcripción</div>
                    {{ transcripcion }}
                  </v-col>
                  <v-btn color="indigo" dark small class="text-capitalize mb-2 mr-2" @click="verWordTranscripcion()">
                    <v-icon left small>mdi-eye</v-icon>
                    Ver Word
                  </v-btn>
                  <v-btn color="indigo" outlined small class="text-capitalize mb-2" @click="descargarWord(form)">
                    <v-icon left small>mdi-file-word</v-icon>
                    Descargar Word
                  </v-btn>
                </v-row>

                <v-card outlined class="pa-4 mt-3" v-if="wordRevisado">
                  <div class="text-subtitle-2 mb-1">Documento con Claude</div>
                  <div class="text-caption grey--text text--darken-1 mb-3">
                    Antes de enviar puedes ver el prompt, editarlo y anexar un Word de ejemplo.
                  </div>
                  <v-btn
                    v-if="!form.claude_texto"
                    color="deep-purple"
                    dark
                    small
                    class="text-capitalize"
                    @click="abrirEnvioClaude()"
                  >
                    <v-icon left small>mdi-robot-outline</v-icon>
                    Procesar con Claude
                  </v-btn>
                  <div v-else>
                    <div class="text-justify grey--text text--darken-1" style="max-height: 140px; overflow-y: auto;">
                      {{ form.claude_texto }}
                    </div>
                    <div class="d-flex flex-wrap align-center mt-3">
                      <v-btn small class="text-capitalize mr-2 mb-2" color="deep-purple" dark @click="verWordClaude()">
                        <v-icon left small>mdi-eye</v-icon>
                        Ver
                      </v-btn>
                      <v-btn small class="text-capitalize mr-2 mb-2" color="deep-purple" outlined @click="descargarClaudeWord()">
                        <v-icon left small>mdi-file-word</v-icon>
                        Descargar Word
                      </v-btn>
                      <v-btn
                        v-if="!claudeAutorizado"
                        small
                        class="text-capitalize mr-2 mb-2"
                        color="success"
                        dark
                        :loading="autorizandoClaude"
                        @click="autorizarClaudeWord()"
                      >
                        <v-icon left small>mdi-check</v-icon>
                        Autorizar
                      </v-btn>
                      <v-btn
                        v-else
                        small
                        class="text-capitalize mr-2 mb-2"
                        color="orange darken-2"
                        dark
                        :loading="generandoManualPdf"
                        @click="generarManualPdf()"
                      >
                        <v-icon left small>mdi-file-pdf-box</v-icon>
                        PDF
                      </v-btn>
                      <v-btn small text class="text-capitalize mb-2" @click="abrirEnvioClaude()">
                        Volver a procesar
                      </v-btn>
                    </div>
                    <div v-if="claudeAutorizado" class="text-caption grey--text text--darken-1 mt-1">
                      Word autorizado. El PDF se guarda como Manual de operación.
                    </div>
                    <div v-if="getPdfNombre(form, 'manual')" class="mt-2">
                      <v-btn small text color="orange darken-2" class="text-capitalize" @click="verPdf(form, 'manual')">
                        <v-icon left small>mdi-eye</v-icon>
                        Ver Manual de operación
                      </v-btn>
                    </div>
                  </div>
                </v-card>
              </v-card>

              <v-card outlined class="pa-4 mt-3" v-if="blueprint || pdfURL || pdfBase64">
                <v-row align="center" justify="center">
                  <v-col cols="12" class="text-center grey--text text--darken-1">
                    Se generó el PDF del proceso a partir del audio. Puedes verlo o descargarlo.
                  </v-col>
                  <v-col cols="12" class="text-center">
                    <v-btn small color="primary" text @click="definePdfDwnl">
                      Descargar PDF generado
                    </v-btn>
                    <v-btn small color="primary" text v-if="blueprint" @click="markdownDialog = true">
                      Ver contenido
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
            </v-stepper-content>

            <v-stepper-content step="3">
          <!-- === Sección de documentos PDF del proceso === -->
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-2 mb-3">Documentos del proceso (PDF)</div>
              <v-card outlined class="pa-4">
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="text-caption mb-2">1. Archivo del Proceso</div>
                    <v-file-input
                      v-model="archivoProcesoPdf"
                      :disabled="!modoEdicion"
                      accept="application/pdf"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-pdf-box"
                      label="Subir Archivo del Proceso (PDF)"
                      @change="onPdfChange($event, 'archivo')"
                    />
                    <div class="d-flex align-center mt-2" v-if="getPdfNombre(form, 'archivo') || archivoProcesoPdf">
                      <v-btn small class="mr-2" color="primary" @click="verPdf(form, 'archivo')">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn small class="mr-2" color="primary" @click="descargarPdfProceso(form, 'archivo')">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="modoEdicion" small class="mr-2" color="error" @click="eliminarPdfProceso('archivo')">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="getPdfNombre(form, 'archivo')" class="text-caption mt-2 blue--text text--darken-2">
                      Archivo actual: {{ getPdfNombre(form, 'archivo') }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="text-caption mb-2">2. Diagrama del proceso</div>
                    <v-file-input
                      v-model="diagramaProcesoPdf"
                      :disabled="!modoEdicion"
                      accept="application/pdf"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-pdf-box"
                      label="Subir Diagrama del Proceso (PDF)"
                      @change="onPdfChange($event, 'diagrama')"
                    />
                    <div class="d-flex align-center mt-2" v-if="getPdfNombre(form, 'diagrama') || diagramaProcesoPdf">
                      <v-btn small class="mr-2" color="secondary" @click="verPdf(form, 'diagrama')">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn small class="mr-2" color="secondary" @click="descargarPdfProceso(form, 'diagrama')">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="modoEdicion" small class="mr-2" color="error" @click="eliminarPdfProceso('diagrama')">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="getPdfNombre(form, 'diagrama')" class="text-caption mt-2 red--text text--darken-2">
                      Archivo actual: {{ getPdfNombre(form, 'diagrama') }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="text-caption mb-2">3. Manual de operación</div>
                    <v-file-input
                      v-model="manualOperacionPdf"
                      :disabled="!modoEdicion"
                      accept="application/pdf"
                      filled
                      dense
                      clearable
                      prepend-icon="mdi-file-pdf-box"
                      label="Subir Manual de operación (PDF)"
                      @change="onPdfChange($event, 'manual')"
                    />
                    <div class="d-flex align-center mt-2" v-if="getPdfNombre(form, 'manual') || manualOperacionPdf">
                      <v-btn small class="mr-2" color="orange darken-2" dark @click="verPdf(form, 'manual')">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                      <v-btn small class="mr-2" color="orange darken-2" dark @click="descargarPdfProceso(form, 'manual')">
                        <v-icon small>mdi-download</v-icon>
                      </v-btn>
                      <v-btn v-if="modoEdicion" small class="mr-2" color="error" @click="eliminarPdfProceso('manual')">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="getPdfNombre(form, 'manual')" class="text-caption mt-2 orange--text text--darken-3">
                      Archivo actual: {{ getPdfNombre(form, 'manual') }}
                    </div>
                  </v-col>
                  <v-col cols="12" class="text-center mt-3 grey--text text--darken-1"
                    v-if="!getPdfNombre(form, 'archivo') && !archivoProcesoPdf && !getPdfNombre(form, 'diagrama') && !diagramaProcesoPdf && !getPdfNombre(form, 'manual') && !manualOperacionPdf">
                    No hay PDFs cargados para este proceso.
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="text-subtitle-1 font-weight-medium mb-1">Liberación</div>
              <div class="text-body-2 grey--text text--darken-1 mb-4">
                El proceso permanece pendiente hasta que el director lo autorice.
              </div>

              <v-alert v-if="!form.id" type="info" text dense border="left">
                Guarda el proceso para poder liberarlo.
              </v-alert>

              <v-row v-else>
                <v-col cols="12" md="4">
                  <v-card outlined class="fase-caja pa-4 text-center">
                    <div class="text-caption grey--text text--darken-1 mb-3">Estatus</div>
                    <v-chip dark :color="getColorEstatus(getEstatus(form.estatus), form.estatus)">
                      {{ getEstatus(form.estatus) || 'Pendiente' }}
                    </v-chip>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined class="fase-caja pa-4 text-center">
                    <div class="text-caption grey--text text--darken-1 mb-3">Director</div>
                    <v-chip
                      label
                      :color="form.validacion_lider ? 'success' : (canValidarDirector(form) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="form.validacion_lider ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(form, 'lider')"
                    >
                      <v-icon left small>{{ form.validacion_lider ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ form.validacion_lider ? 'Autorizado' : 'Pendiente' }}
                    </v-chip>
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card outlined class="fase-caja pa-4 text-center">
                    <div class="text-caption grey--text text--darken-1 mb-3">Jefe de control interno</div>
                    <v-chip
                      label
                      :color="form.validacion_socio ? 'success' : (canValidarControlInterno(form) ? 'amber lighten-3' : 'grey lighten-2')"
                      :text-color="form.validacion_socio ? 'white' : 'grey darken-2'"
                      @click="updateTareaCheck(form, 'socio')"
                    >
                      <v-icon left small>{{ form.validacion_socio ? 'mdi-check' : 'mdi-close' }}</v-icon>
                      {{ form.validacion_socio ? 'Validado' : 'Pendiente' }}
                    </v-chip>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="form.audio_name && !transcripcion && !form.validacion_lider">
                  <v-alert type="warning" text dense border="left" class="mb-0">
                    Cuando el director autorice, en la fase de audio aparecerá el botón Transcribir y el archivo en Word.
                  </v-alert>
                </v-col>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>

        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn text small :disabled="Number(faseEdicion) <= 1" @click="faseAnterior">
            <v-icon left small>mdi-chevron-left</v-icon>
            Anterior
          </v-btn>
          <v-btn text small color="primary" :disabled="Number(faseEdicion) >= 4" @click="faseSiguiente">
            Siguiente
            <v-icon right small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text small color="red" @click="dialog = false">Cerrar</v-btn>
          <v-btn v-if="puedeEditar && !modoEdicion" color="primary" dark small tile class="ml-2" @click="editarProceso()">
            <v-icon left small>mdi-pencil</v-icon>
            Editar
          </v-btn>
          <v-btn v-if="modoEdicion" color="green" dark small tile class="ml-2" @click="guardar">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ConfirmDialog v-model="confirm" :titulo="confirmTitulo" :mensaje="confirmMensaje" @emitConfirm="requestUpdateValidacion" />
    <MarkdownViewer v-model="markdownDialog" :markdown="renderedMarkdown" />
    <guia-grabacion-audio v-model="mostrarGuia" @empezar-grabacion="iniciarGrabacionDesdeGuia" />
    <v-dialog v-model="pdfPreviewDialog" max-width="1100px">
      <v-card>
        <v-card-title class="text-subtitle-1">{{ pdfPreviewTitle }}</v-card-title>
        <v-card-text style="height: 75vh;">
          <iframe v-if="pdfPreviewUrl" :src="pdfPreviewUrl" width="100%" height="100%" style="border: none;"></iframe>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="primary" :disabled="!pdfPreviewTipo" @click="descargarPdfPreview">
            <v-icon left small>mdi-download</v-icon>
            Descargar PDF
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="cerrarPreviewPdf">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

    <!-- Dialog para Documentos (DOC/PDF) -->
    <v-dialog v-model="dialogDocumento" max-width="600px" persistent>
      <v-card class="shadowCard">
        <v-card-title primary-title>
          <span class="text-subtitle-1">{{ formDoc.id ? 'Editar' : 'Nuevo' }} Documento de Proceso</span>
        </v-card-title>
        <v-card-text>
          <v-alert type="info" text border="left" class="mb-4" dense outlined>
            <div class="text-caption">
              <b>Importante:</b> Una vez que el documento sea subido al servidor,
              los datos base (Folio, Nombre, Depto) y el archivo <b>no podrán ser editados</b>. 
              Solo se permitirá la actualización de estatus y comentarios.
            </div>
          </v-alert>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="formDoc.folio" label="Folio de documento" filled dense disabled></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="formDoc.nombre_documento" label="Nombre del documento" filled dense :disabled="!canEdit"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete v-model="formDoc.id_departamento" :items="departamentos" item-text="departamento"
                item-value="id" label="Seleccionar departamento" filled dense clearable :disabled="!canEdit"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-file-input v-model="archivoDoc" label="Subir archivo (PDF, DOC, DOCX)" accept=".pdf,.doc,.docx" filled
                dense prepend-icon="mdi-file-document" :disabled="!!formDoc.id"></v-file-input>
              <div v-if="formDoc.archivo_nombre" class="text-caption blue--text">
                Archivo actual: {{ formDoc.archivo_nombre }}
              </div>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="formDoc.comentarios" label="Comentarios" filled dense rows="3" auto-grow></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-select v-model="formDoc.estatus" :items="['Pendiente', 'Aprobado', 'Rechazado']" label="Estatus" filled
                dense></v-select>
            </v-col>
            <v-col cols="12" md="6" v-if="[1, 2574].includes(this.getdatosUsuarioERPERP.iderp)">
              <v-checkbox v-model="formDoc.validacion_dc" label="Validación Dirección y Calidad" color="success" dense></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="dialogDocumento = false" small tile>Cancelar</v-btn>
          <v-btn color="green" dark @click="guardarDocumento" small tile>Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogClaude" max-width="760" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Enviar a Claude</v-card-title>
        <v-card-text>
          <div class="text-body-2 grey--text text--darken-1 mb-3">
            Este es el prompt. Puedes editarlo para este envío. A Claude se manda el prompt, el Word de ejemplo y la transcripción.
          </div>
          <v-textarea
            v-model="promptClaude"
            label="Prompt"
            outlined
            rows="8"
            auto-grow
            :loading="cargandoPromptClaude"
          ></v-textarea>
          <v-file-input
            v-model="ejemploClaude"
            class="mt-4"
            accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            label="Word de ejemplo (.docx)"
            prepend-icon="mdi-file-word"
            outlined
            dense
            show-size
            clearable
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogClaude = false" :disabled="procesandoClaude">Cancelar</v-btn>
          <v-btn color="deep-purple" dark small class="text-capitalize" :loading="procesandoClaude" @click="enviarAClaude()">
            <v-icon left small>mdi-send</v-icon>
            Enviar a Claude
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTexto" max-width="760">
      <v-card>
        <v-card-title class="text-subtitle-1">{{ dialogTextoTitulo }}</v-card-title>
        <v-card-text>
          <div class="text-body-2" style="white-space: pre-wrap; max-height: 60vh; overflow-y: auto;">{{ dialogTextoCuerpo }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogTexto = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPrompt" max-width="760" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Prompt de transcripción</v-card-title>
        <v-card-text>
          <div class="text-body-2 grey--text text--darken-1 mb-3">
            Este texto se guarda y se envía al transcribir el audio de un proceso.
          </div>
          <v-textarea
            v-model="promptProceso"
            label="Prompt"
            outlined
            rows="12"
            auto-grow
            hide-details
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogPrompt = false" small tile>Cerrar</v-btn>
          <v-btn color="success" dark class="text-capitalize" @click="guardarPromptProceso()" :loading="guardandoPrompt" small tile>
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
// Componentes
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue';
import ConfirmDialog from '@/components/procesos/ConfirmDialog.vue'
import GuiaGrabacionAudio from '@/components/procesos/GuiaAudioDialog.vue'
import MarkdownViewer from '@/components/procesos/MarkdownDialog.vue'
import validarErrores from '@/mixins//validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true,
})

export default {
  mixins: [validarErrores, funcionesExcel],

  components: {
    Alerta,
    carga,
    ConfirmDialog,
    GuiaGrabacionAudio,
    MarkdownViewer,
  },

  data: () => ({
    attrs: {
      class: 'mb-6',
      boilerplate: true,
      elevation: 2,
    },
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    mostrarGuia: false,
    dialogPrompt: false,
    promptProceso: '',
    guardandoPrompt: false,
    showSkeleton: false,
    respuestaAlerta: false,
    loader: true,
    cargar: false,
    search: '',
    departamentoFiltro: '',
    avanceTotal: 75,
    procesosCompletados: 4,
    procesosPendientes: 3,
    procesosRechazados: 3,
    procesos: [],
    departamentos: [],
    personal: [],
    headersValidacion: [
      { text: '#', value: 'index', width: '48px' },
      { text: 'Procesos', value: 'titulo' },
      { text: 'Tipo de documentación', value: 'tipo_documentacion', width: '170px' },
      { text: 'Fecha de documentación', value: 'fecha_documentacion', width: '160px' },
      { text: 'Quién asistió', value: 'quien_asistio', width: '180px' },
      { text: 'Escuela', value: 'escuela' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Dueño de proceso', value: 'jefe_depto' },
      { text: 'Documentador', value: 'responsable' },
      { text: 'Documentos del proceso', value: 'documentosProceso', sortable: false },
      { text: 'Validación por Director', value: 'validacionLider', sortable: false },
      { text: 'Validación por Jefe de Control Interno', value: 'validacionSocio', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: '', value: 'acciones', sortable: false },
    ],
    modoEdicion: false,
    puedeEditar: false,
    dialog: false,
    faseEdicion: 1,
    form: {
      id: null,
      id_departamento: '',
      id_usuario: '',
      nombre_completo: '',
      titulo: '',
      proceso: '',
      observacion: '',
      id_jefe_departamento: 0,
      id_responsable: 0,
      escuela: 1,
    },
    archivoProcesoPdf: null,
    diagramaProcesoPdf: null,
    manualOperacionPdf: null,
    archivoProcesoExistente: '',
    diagramaProcesoExistente: '',
    manualOperacionExistente: '',
    eliminarArchivoProcesoPdf: false,
    eliminarDiagramaProcesoPdf: false,
    eliminarManualOperacionPdf: false,
    tiposDocumentacion: ['Autoasistida', 'Asistida'],
    asistentesDocumentacion: ['Devany Molina', 'Alejandro Guerra', 'David Molina'],
    transcribiendoId: null,
    pdfPreviewDialog: false,
    pdfPreviewUrl: '',
    pdfPreviewTitle: '',
    pdfPreviewTipo: '',
    pdfPreviewItem: null,
    // Audio / transcripción
    audioUrl: null,
    audioBlob: null,
    audioStream: null,
    mediaRecorder: null,
    audioChunks: [],
    archivoAudio: null,
    isRecording: false,
    hasRecordedAudio: false,
    transcripcion: '',
    procesandoClaude: false,
    dialogClaude: false,
    promptClaude: '',
    ejemploClaude: null,
    cargandoPromptClaude: false,
    autorizandoClaude: false,
    generandoManualPdf: false,
    dialogTexto: false,
    dialogTextoTitulo: '',
    dialogTextoCuerpo: '',
    blueprint: '',
    pdfBase64: '',
    pdfURL: '',
    markdownDialog: false,
    pdfName: 'procesos.pdf',
    audioName: '',
    URL_AUDIO: 'https://escuelakpi.club/audios/',
    confirm: false,
    confirmMensaje: "",
    confirmTitulo: "",
    validacionDueno: false,
    validacionLider: false,
    validacionSocio: false,
    fromValidation: "",
    // Data para nueva tabla de documentos
    dialogDocumento: false,
    archivoDoc: null,
    documentosProcesos: [],
    formDoc: {
      id: null,
      folio: '',
      nombre_documento: '',
      archivo_nombre: '',
      estatus: 'Pendiente',
      validacion_dc: 0,
      comentarios: '',
      id_departamento: ''
    },
    headersDocumentos: [
      { text: 'Folio', value: 'folio' },
      { text: 'Nombre Documento', value: 'nombre_documento' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Documento', value: 'archivo_nombre', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Validación D.C.', value: 'validacion_dc', sortable: false },
      { text: 'Comentarios', value: 'comentarios' },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    puestos:[11, 12, 40, 54, 56, 68, 107],

    accesosProcesos: [1, 718, 334, 568, 1312, 2720],
    // Data para nueva tabla de documentos
    dialogDocumento: false,
    archivoDoc: null,
    documentosProcesos: [],
    formDoc: {
      id: null,
      folio: '',
      nombre_documento: '',
      archivo_nombre: '',
      estatus: 'Pendiente',
      validacion_dc: 0,
      comentarios: '',
      id_departamento: ''
    },
    headersDocumentos: [
      { text: 'Folio', value: 'folio' },
      { text: 'Nombre Documento', value: 'nombre_documento' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Documento', value: 'archivo_nombre', sortable: false },
      { text: 'Estatus', value: 'estatus' },
      { text: 'Validación D.C.', value: 'validacion_dc', sortable: false },
      { text: 'Comentarios', value: 'comentarios' },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
    puestos:[11, 12, 40, 54, 56, 68, 107]
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    canEdit() {
      return [12, 107,11].includes(this.getdatosUsuarioERPERP.idpuesto)
    },
    puedeEditarPrompt() {
      const usuario = this.getdatosUsuarioERPERP || {}
      const id = Number(usuario.iderp)
      return id === 1 || id === 334
    },
    isDataLoaded() {
      return this.procesos && this.procesos.length ? true : false;
    },
    getNew() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'new') : []
    },
    getCompleted() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'approved') : []
    },
    getReview() {
      return this.isDataLoaded
        ? this.procesos.filter(it => it.estatus !== 'approved' && it.estatus !== 'refuse')
        : []
    },
    getReject() {
      return this.isDataLoaded ? this.procesos.filter(it => it.estatus == 'refuse') : []
    },
    /** Denominador: todos los procesos listados (incluye aprobados) para que el % de avance tenga sentido. */
    getTotal() {
      return this.isDataLoaded ? this.procesos.length : 0
    },
    avancePorcentaje() {
      if (!this.isDataLoaded || this.getTotal === 0) {
        return 0
      }
      return Math.round((this.getCompleted.length / this.getTotal) * 100)
    },
    procesosFiltrados() {
      let procesosExtendidos = this.procesos.map((proc, index) => ({
        ...proc,
        grabando: false,
        chunks: [],
        validacionDueno: false,
        validacionLider: false,
        validacionSocio: false,
        isPlaying: false,
        audioObj: null,
        /** Clave backend: approved | onReview | refuse | new */
        estatusKey: proc.estatus,
        estatus: this.getEstatus(proc.estatus),
      }));

      if (!this.departamentoFiltro) {
        return procesosExtendidos;
      }
      return procesosExtendidos.filter(proc => proc.id_departamento === this.departamentoFiltro);
    },

    filterJefes() {
      return this.personal.filter(el => (el.puesto.match('JEFE') && !el.puesto.match('ASISTENTE')) || el.puesto.match('DIRECTOR'));
    },

    filterResponsables() {
      return this.personal;
    },
    documentosFiltrados() {
      if (!this.departamentoFiltro) {
        return this.documentosProcesos;
      }
      return this.documentosProcesos.filter(doc => doc.id_departamento === this.departamentoFiltro);
    },
    renderedMarkdown() {
      return this.blueprint ? md.render(this.blueprint) : ''
    },
    puedeTranscribirForm() {
      return this.puedeTranscribir(this.form)
    },
    wordRevisado() {
      return Number(this.form && this.form.transcripcion_revisada) === 1
    },
    claudeAutorizado() {
      return Number(this.form && this.form.claude_autorizado) === 1
    },
  },

  async created() {
    await this.initialize();
    await this.getDepartamentos();
    await this.getJefesDepartamento();
    await this.initializeDocumentos();
  },

  methods: {
    showRecording() {
      if ([718].includes(this.getdatosUsuarioERPERP.id_usuario)) {
        return true
      }
      if ([2230, 954].includes(this.getdatosUsuarioERPERP.iderp)) {
        return true
      }
      // Al crear proceso nuevo, permitir grabar al usuario en edición
      if (!this.form.id && this.modoEdicion) {
        return true
      }
      return this.form.id_responsable == this.getdatosUsuarioERPERP.id_trabajador
    },
    initialize() {
      this.cargar = true;
      this.procesos = [];
      this.$http.get('get.todos.los.procesos').then(response => {
        this.procesos = response.data;

        if( !this.accesosProcesos.includes(this.getdatosUsuarioERPERP.iderp) ){
          this.procesos = this.procesos.filter(it => it.id_responsable == this.getdatosUsuarioERPERP.id_trabajador)
        }

        if (this.procesos && this.procesos.length) {
          this.procesos.forEach(it => {
            it.validacion_dueno = it.validacion_dueno ? true : false;
            it.validacion_lider = it.validacion_lider ? true : false;
            it.validacion_socio = it.validacion_socio ? true : false;
          })
        }
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },

    getDepartamentos() {
      this.cargar = true;
      this.departamentos = [];
      this.$http.get('get.todos.los.departamentos').then(response => {
        this.departamentos = response.data;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },
    getJefesDepartamento() {
      this.cargar = true;
      this.personal = [];
      this.$http.get('get.jefes.departamento').then(response => {
        this.personal = response.data;
        this.cargar = false;
      }).catch(error => {
        this.validarError(error.response.data.message);
      }).finally(() => { this.cargar = false; });
    },
    getEstatus(sts) {
      const estatusMap = {
        approved: 'Aprobado',
        onReview: 'Pendiente',
        pending: 'Pendiente',
        refuse: 'Rechazado',
        new: 'Pendiente'
      };
      const key =
        sts && typeof sts === 'string'
          ? String(sts).trim()
          : sts;
      if (Object.prototype.hasOwnProperty.call(estatusMap, key)) {
        return estatusMap[key];
      }
      if (sts === 'En Revisión' || sts === 'Nuevo' || sts === 'Pendiente') {
        return 'Pendiente';
      }
      if (sts === 'Aprobado' || sts === 'Rechazado') {
        return sts;
      }
      return sts || '';
    },

    getColorEstatus(estatus, estatusKey) {
      if (estatusKey === 'approved') return 'green darken-2';
      if (estatusKey === 'refuse') return 'red darken-2';
      const texto = typeof estatus === 'string' ? estatus.trim().toLowerCase() : '';
      if (texto === 'aprobado' || texto === 'approve') return 'green darken-2';
      if (texto === 'pendiente' || texto.includes('revisión') || texto.includes('revision') || texto === 'nuevo') return 'amber darken-2';
      if (texto === 'rechazado') return 'red darken-2';
      return 'amber darken-2';
    },
    formatFecha(fecha) {
      if (!fecha) return '—'
      const texto = String(fecha).slice(0, 10)
      const partes = texto.split('-')
      if (partes.length !== 3) return texto
      return partes[2] + '/' + partes[1] + '/' + partes[0]
    },
    onTipoDocumentacionChange(valor) {
      if (valor !== 'Asistida' && this.form) {
        this.form.quien_asistio = ''
      }
    },
    puedeTranscribir(item) {
      if (!item || !item.id || !item.audio_name || item.transcription) return false
      return !!item.validacion_lider
    },

    abrirDialog(item, edit) {
      const raw = this.procesos.find((p) => p.id === item.id)
      this.form = { ...item }
      delete this.form.estatusKey
      delete this.form.grabando
      delete this.form.chunks
      delete this.form.isPlaying
      delete this.form.audioObj
      if (raw != null && raw.estatus != null) {
        this.form.estatus = raw.estatus
      }
      if (this.form.escuela == null || this.form.escuela === undefined || this.form.escuela === '') {
        this.form.escuela = 1;
      }
      if (this.form.fecha_documentacion) {
        this.form.fecha_documentacion = String(this.form.fecha_documentacion).slice(0, 10)
      }
      this.resetAudioState()
      if (item.audio_name) {
        this.audioName = item.audio_name
        this.transcripcion = item.transcription || ''
        this.pdfURL = item.pdf_name || ''
      }
      this.archivoProcesoPdf = null;
      this.diagramaProcesoPdf = null;
      this.manualOperacionPdf = null;
      this.archivoProcesoExistente = this.getPdfNombre(item, 'archivo') || '';
      this.diagramaProcesoExistente = this.getPdfNombre(item, 'diagrama') || '';
      this.manualOperacionExistente = this.getPdfNombre(item, 'manual') || '';
      this.eliminarArchivoProcesoPdf = false;
      this.eliminarDiagramaProcesoPdf = false;
      this.eliminarManualOperacionPdf = false;
      const acceso = this.tieneAccesoAlProceso(item)
      this.puedeEditar = false
      this.modoEdicion = false
      this.faseEdicion = 1
      this.dialog = true
      if (edit && acceso) {
        this.puedeEditar = true
        this.modoEdicion = true
      }
    },


    abrirPrompt() {
      this.dialogPrompt = true
      this.cargar = true
      this.$http.get('procesos.prompt').then(response => {
        const data = response.data || {}
        this.promptProceso = data.prompt || ''
      }).catch(error => {
        let msg = 'No se pudo cargar el prompt'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally(() => {
        this.cargar = false
      })
    },

    guardarPromptProceso() {
      this.guardandoPrompt = true
      this.$http.post('procesos.prompt', { prompt: this.promptProceso || '' }).then(() => {
        this.validarSuccess('Prompt guardado')
        this.dialogPrompt = false
      }).catch(error => {
        let msg = 'No se pudo guardar el prompt'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally(() => {
        this.guardandoPrompt = false
      })
    },

    crearProceso() {
      this.form = {
        id: null,
        id_departamento: '',
        id_usuario: '',
        nombre_completo: '',
        titulo: '',
        proceso: '',
        observacion: '',
        id_jefe_departamento: '',
        id_responsable: '',
        escuela: 1,
        audioBase64: null,
        audio_name: '',
        tipo_documentacion: '',
        fecha_documentacion: '',
        quien_asistio: '',
      };
      this.resetAudioState()
      this.archivoProcesoPdf = null;
      this.diagramaProcesoPdf = null;
      this.manualOperacionPdf = null;
      this.archivoProcesoExistente = '';
      this.diagramaProcesoExistente = '';
      this.manualOperacionExistente = '';
      this.eliminarArchivoProcesoPdf = false;
      this.eliminarDiagramaProcesoPdf = false;
      this.eliminarManualOperacionPdf = false;
      this.faseEdicion = 1;
      this.modoEdicion = true;
      this.dialog = true;
    },

    editarProceso() {
      this.modoEdicion = true;
    },
    canGestionarDueno(item) {
      return Number(item.id_usuario) === Number(this.getdatosUsuarioERPERP.iderp);
    },
    canGestionarDirector() {
      return Number(this.getdatosUsuarioERPERP.iderp) === 1;
    },
    canGestionarControlInterno() {
      return Number(this.getdatosUsuarioERPERP.iderp) === 718;
    },
    canValidarDueno(item) {
      return this.canGestionarDueno(item);
    },
    canValidarDirector() {
      return this.canGestionarDirector();
    },
    canValidarControlInterno(item) {
      if (!this.canGestionarControlInterno()) return false;
      if (item.validacion_socio) return true;
      return !!item.validacion_lider;
    },
    updateTareaCheck(item, from) {
      if (from === 'dueno') return;
      if (from === 'lider' && !this.canValidarDirector(item)) return;
      if (from === 'socio' && !this.canValidarControlInterno(item)) return;

      const nextDueno = !!item.validacion_dueno;
      const nextLider = from === 'lider' ? !item.validacion_lider : !!item.validacion_lider;
      const nextSocioBase = from === 'socio' ? !item.validacion_socio : !!item.validacion_socio;
      const nextSocio = nextLider ? nextSocioBase : false;

      this.confirmTitulo = "Confirmación"
      if (from == 'dueno') {
        this.confirmMensaje = nextDueno
          ? "¿Marcar como válido al dueño del proceso?"
          : "¿Regresar a inválido al dueño del proceso?"
      }
      if (from == 'lider') {
        this.confirmMensaje = nextLider
          ? "¿Marcar como válido al director?"
          : "¿Regresar a inválido al director?"
      }
      if (from == 'socio') {
        this.confirmMensaje = nextSocio
          ? "¿Marcar como válido al jefe de control interno?"
          : "¿Regresar a inválido al jefe de control interno?"
      }
      this.form = item
      this.fromValidation = from
      this.validacionDueno = nextDueno
      this.validacionLider = nextLider
      this.validacionSocio = nextSocio
      this.confirm = true
    },
    async requestUpdateValidacion() {
      this.confirm = false
      try {
        const form = {
          id: this.form.id,
          validacion_dueno:this.validacionDueno,
          validacion_lider: this.validacionLider,
          validacion_socio: this.validacionSocio
        }
        
        const response = await this.$http.put('update.validacion', form)
        const dialogAbierto = this.dialog && this.form && this.form.id

        if (response.data) {
          if (dialogAbierto) {
            this.$set(this.form, 'validacion_dueno', !!this.validacionDueno)
            this.$set(this.form, 'validacion_lider', !!this.validacionLider)
            this.$set(this.form, 'validacion_socio', !!this.validacionSocio)
            if (this.form.estatus !== 'refuse') {
              this.$set(this.form, 'estatus', this.validacionLider ? 'approved' : 'onReview')
            }
          } else {
            this.form = {}
          }
          this.fromValidation = null
          this.validacionDueno = null
          this.validacionLider = null
          this.validacionSocio = null

          this.validarSuccess('Proceso actualizado correctamente');
          this.initialize();
        }

      } catch (error) {
        console.error(error);
      }
    },
    guardar() {
      if (!this.form.titulo) {
        this.$swal({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Debes llenar el título del proceso.',
        });
        return;
      }
      if (this.form.tipo_documentacion === 'Asistida' && !this.form.quien_asistio) {
        this.$swal({
          icon: 'warning',
          title: 'Quién asistió',
          text: 'Selecciona quién asistió la documentación.',
        });
        return;
      }
      if (!this.form.id_usuario) {
        this.form.id_usuario = this.getdatosUsuarioERPERP.id_usuario;
        this.form.nombre_completo = this.getdatosUsuarioERPERP.nombre_completo;
      }

      const formData = new FormData();
      formData.append('id', this.form.id);
      formData.append('titulo', this.form.titulo);
      formData.append('proceso', this.form.proceso);
      formData.append('id_usuario', this.form.id_usuario);
      formData.append('estatus', this.form.estatus);
      formData.append('id_responsable', this.form.id_responsable);
      formData.append('id_jefe_departamento', this.form.id_jefe_departamento);
      formData.append('validacion_dueno', this.form.validacion_dueno);
      formData.append('validacion_lider', this.form.validacion_lider);
      formData.append('validacion_socio', this.form.validacion_socio);
      formData.append('nombre_completo', this.form.nombre_completo);
      formData.append('id_departamento', this.form.id_departamento);
      formData.append('escuela', this.form.escuela || 1);
      formData.append('tipo_documentacion', this.form.tipo_documentacion || '');
      formData.append('fecha_documentacion', this.form.fecha_documentacion || '');
      formData.append('quien_asistio', this.form.tipo_documentacion === 'Asistida' ? (this.form.quien_asistio || '') : '');

      if (this.archivoProcesoPdf) {
        formData.append('archivo_proceso_pdf', this.archivoProcesoPdf);
      }
      if (this.diagramaProcesoPdf) {
        formData.append('diagrama_proceso_pdf', this.diagramaProcesoPdf);
      }
      if (this.manualOperacionPdf) {
        formData.append('manual_operacion_pdf', this.manualOperacionPdf);
      }
      formData.append('eliminar_archivo_proceso_pdf', this.eliminarArchivoProcesoPdf ? 1 : 0);
      formData.append('eliminar_diagrama_proceso_pdf', this.eliminarDiagramaProcesoPdf ? 1 : 0);
      formData.append('eliminar_manual_operacion_pdf', this.eliminarManualOperacionPdf ? 1 : 0);

      if (this.audioBlob) {
        formData.append('audio', this.audioBlob, 'grabacion.webm');
      } else if (this.archivoAudio) {
        const nombreAudio = this.archivoAudio.name || 'audio.webm';
        formData.append('audio', this.archivoAudio, nombreAudio);
      }

      this.cargar = true;
      this.$http.post('crear.proceso', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(response => {
        const { success, proceso } = response.data
        if (success) {
          this.validarSuccess('Proceso guardado correctamente');
          if (!this.form.id && response.data.result && response.data.result.insertId) {
            this.form.id = response.data.result.insertId
          }
          this.initialize();
          this.archivoProcesoExistente = this.getPdfNombre(proceso || this.form, 'archivo') || '';
          this.diagramaProcesoExistente = this.getPdfNombre(proceso || this.form, 'diagrama') || '';
          this.manualOperacionExistente = this.getPdfNombre(proceso || this.form, 'manual') || '';
          if (proceso && proceso.audio_name) {
            this.form.audio_name = proceso.audio_name
            this.audioName = proceso.audio_name
            this.transcripcion = ''
            this.form.transcription = ''
            this.audioBlob = null
            this.archivoAudio = null
          }
          if (proceso && proceso.archivo_proceso_pdf_name) {
            this.form.archivo_proceso_pdf_name = proceso.archivo_proceso_pdf_name
            this.archivoProcesoExistente = proceso.archivo_proceso_pdf_name
          }
          if (proceso && proceso.diagrama_proceso_pdf_name) {
            this.form.diagrama_proceso_pdf_name = proceso.diagrama_proceso_pdf_name
            this.diagramaProcesoExistente = proceso.diagrama_proceso_pdf_name
          }
          if (proceso && proceso.manual_operacion_pdf_name) {
            this.form.manual_operacion_pdf_name = proceso.manual_operacion_pdf_name
            this.manualOperacionExistente = proceso.manual_operacion_pdf_name
          }
          this.archivoProcesoPdf = null
          this.diagramaProcesoPdf = null
          this.manualOperacionPdf = null
          this.eliminarArchivoProcesoPdf = false
          this.eliminarDiagramaProcesoPdf = false
          this.eliminarManualOperacionPdf = false
        }
        this.modoEdicion = false;
      }).catch(error => {
        let msg = 'Error al guardar el proceso'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg);
      }).finally(() => {
        this.cargar = false;
        this.showSkeleton = false
      });
    },

    resetAudioState() {
      this.audioUrl = null
      this.audioBlob = null
      this.archivoAudio = null
      this.isRecording = false
      this.hasRecordedAudio = false
      this.transcripcion = ''
      this.blueprint = ''
      this.pdfBase64 = ''
      this.pdfURL = ''
      this.audioName = ''
      if (this.form) {
        this.form.audioBase64 = null
      }
    },
    iniciarGrabacionDesdeGuia() {
      this.modoEdicion = true
      this.dialog = true
      this.faseEdicion = 2
      this.startRecording()
    },
    faseAnterior() {
      const actual = Number(this.faseEdicion) || 1
      if (actual > 1) this.faseEdicion = actual - 1
    },
    faseSiguiente() {
      const actual = Number(this.faseEdicion) || 1
      if (actual < 4) this.faseEdicion = actual + 1
    },
    async startRecording() {
      try {
        this.audioStream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.mediaRecorder = new MediaRecorder(this.audioStream)
        this.audioChunks = []
        this.isRecording = true
        this.archivoAudio = null

        this.mediaRecorder.ondataavailable = (e) => {
          this.audioChunks.push(e.data)
        }

        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' })
          this.audioUrl = URL.createObjectURL(this.audioBlob)
          this.hasRecordedAudio = true
          this.convertBlobToBase64(this.audioBlob)
          this.audioChunks = []
          this.isRecording = false
          if (this.audioStream) {
            this.audioStream.getTracks().forEach(track => track.stop())
            this.audioStream = null
          }
        }

        this.mediaRecorder.start()
      } catch (err) {
        console.error(err)
        this.validarError('No se pudo acceder al micrófono. Verifica permisos.')
      }
    },
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop()
      }
    },
    onAudioFileChange(file) {
      if (!file) return
      const tipo = file.type || ''
      if (tipo && !tipo.startsWith('audio/') && tipo !== 'video/webm') {
        this.validarError('Solo se permiten archivos de audio.')
        this.archivoAudio = null
        return
      }
      this.audioBlob = null
      this.audioUrl = URL.createObjectURL(file)
      this.hasRecordedAudio = true
      this.form.audioBase64 = null
    },
    clearAudio() {
      if (this.audioUrl && String(this.audioUrl).startsWith('blob:')) {
        URL.revokeObjectURL(this.audioUrl)
      }
      this.audioUrl = null
      this.audioBlob = null
      this.archivoAudio = null
      this.hasRecordedAudio = false
      if (this.form) {
        this.form.audioBase64 = null
      }
    },
    convertBlobToBase64(blob) {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        this.form.audioBase64 = reader.result
      }
    },
    getAudioSrc(base64) {
      return base64 || null
    },
    detenerAudio(item) {
      if (item.audioObj) {
        item.audioObj.pause()
        item.audioObj.currentTime = 0
      }
      item.isPlaying = false
    },
    detenerTodosLosAudios(exceptItem) {
      this.procesos.forEach(proc => {
        if (exceptItem && proc.id === exceptItem.id) return
        if (proc.audioObj && proc.isPlaying) {
          proc.audioObj.pause()
          proc.audioObj.currentTime = 0
          proc.isPlaying = false
        }
      })
    },
    reproducirAudio(item) {
      if (!item.audio_name) return
      if (item.isPlaying) {
        this.detenerAudio(item)
        return
      }
      this.detenerTodosLosAudios(item)
      if (!item.audioObj) {
        item.audioObj = new Audio(this.URL_AUDIO + item.audio_name)
        item.audioObj.onended = () => {
          item.isPlaying = false
        }
      }
      item.audioObj.play()
        .then(() => { item.isPlaying = true })
        .catch(err => {
          item.isPlaying = false
          console.warn('Error reproduciendo:', err)
          this.validarError('No se pudo reproducir el audio.')
        })
    },
    transcribirAudio(item) {
      const proceso = item && item.id ? item : this.form
      if (!proceso || !proceso.id) {
        this.validarError('Guarda el proceso antes de transcribir.')
        return
      }
      if (!proceso.audio_name && !this.audioName) {
        this.validarError('Este proceso no tiene audio para transcribir.')
        return
      }
      if (!proceso.validacion_lider) {
        this.validarError('El director debe autorizar el proceso antes de transcribir el audio.')
        return
      }
      this.transcribiendoId = proceso.id
      this.showSkeleton = true
      this.cargar = true
      this.$http.post('transcribir.proceso', { id: proceso.id }, { timeout: 1500000 }).then(response => {
        const data = response.data || {}
        if (data.success) {
          this.validarSuccess('Audio transcrito. Ya puedes descargar el Word.')
          if (this.form && this.form.id === proceso.id) {
            this.transcripcion = data.transcription || ''
            this.form.transcription = data.transcription || ''
            this.$set(this.form, 'transcripcion_revisada', 0)
            this.$set(this.form, 'claude_texto', '')
            this.$set(this.form, 'claude_autorizado', 0)
          }
          this.initialize()
        }
      }).catch(error => {
        let msg = 'No fue posible transcribir el audio'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally(() => {
        this.transcribiendoId = null
        this.showSkeleton = false
        this.cargar = false
      })
    },
    descargarWord(item) {
      const id = item && item.id ? item.id : (this.form && this.form.id)
      if (!id) return
      this.cargar = true
      this.$http.get('descargar.transcripcion.word/' + id, { responseType: 'blob' }).then(response => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })
        const urlBlob = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', 'transcripcion-' + id + '.docx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlBlob)
        this.marcarWordRevisado(id)
      }).catch(() => {
        this.validarError('No se pudo descargar el Word.')
      }).finally(() => {
        this.cargar = false
      })
    },
    marcarWordRevisado(id) {
      if (!id) return
      this.$http.post('procesos.word.revisado', { id }).then(() => {
        if (this.form && this.form.id === id) {
          this.guardarCampoProceso({ transcripcion_revisada: 1 })
          return
        }
        const fila = this.procesos.find((proceso) => proceso.id === id)
        if (fila) fila.transcripcion_revisada = 1
      }).catch(() => {})
    },
    mensajeHttp(error, fallback) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      return fallback
    },
    guardarCampoProceso(campos) {
      Object.keys(campos).forEach((clave) => {
        this.$set(this.form, clave, campos[clave])
      })
      const fila = this.procesos.find((proceso) => proceso.id === this.form.id)
      if (!fila) return
      Object.keys(campos).forEach((clave) => {
        fila[clave] = campos[clave]
      })
    },
    verWordTranscripcion() {
      this.dialogTextoTitulo = 'Word de la transcripción'
      this.dialogTextoCuerpo = this.transcripcion || ''
      this.dialogTexto = true
      if (!this.form || !this.form.id) return
      this.marcarWordRevisado(this.form.id)
    },
    abrirEnvioClaude() {
      if (!this.form || !this.form.id) return
      this.ejemploClaude = null
      this.promptClaude = ''
      this.dialogClaude = true
      this.cargandoPromptClaude = true
      this.$http.get('procesos.prompt').then((response) => {
        const data = response.data || {}
        this.promptClaude = data.prompt || ''
      }).catch((error) => {
        this.validarError(this.mensajeHttp(error, 'No se pudo cargar el prompt'))
      }).finally(() => {
        this.cargandoPromptClaude = false
      })
    },
    archivoEjemploClaude() {
      const valor = this.ejemploClaude
      if (!valor) return null
      if (valor instanceof File) return valor
      if (valor.length && valor[0]) return valor[0]
      return null
    },
    enviarAClaude() {
      if (!this.form || !this.form.id) return
      const prompt = (this.promptClaude || '').trim()
      if (!prompt) {
        this.validarError('Escribe el prompt antes de enviar a Claude.')
        return
      }
      const ejemplo = this.archivoEjemploClaude()
      if (!ejemplo) {
        this.validarError('Anexa un Word de ejemplo (.docx).')
        return
      }
      const nombre = String(ejemplo.name || '').toLowerCase()
      if (nombre.slice(-5) !== '.docx') {
        this.validarError('El ejemplo debe ser un archivo Word .docx.')
        return
      }
      const datos = new FormData()
      datos.append('id', this.form.id)
      datos.append('prompt', prompt)
      datos.append('ejemplo', ejemplo)
      this.procesandoClaude = true
      this.$http.post('procesos.claude', datos, {
        timeout: 600000,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((response) => {
        const data = response.data || {}
        this.guardarCampoProceso({
          claude_texto: data.claude_texto || '',
          claude_autorizado: 0
        })
        this.dialogClaude = false
        this.validarSuccess('Claude generó el documento. Revísalo y, si está bien, autorízalo.')
      }).catch((error) => {
        this.validarError(this.mensajeHttp(error, 'No fue posible procesar con Claude'))
      }).finally(() => {
        this.procesandoClaude = false
      })
    },
    verWordClaude() {
      this.dialogTextoTitulo = 'Word de Claude'
      this.dialogTextoCuerpo = this.form && this.form.claude_texto ? this.form.claude_texto : ''
      this.dialogTexto = true
    },
    descargarClaudeWord() {
      const id = this.form && this.form.id
      if (!id) return
      this.cargar = true
      this.$http.get('descargar.claude.word/' + id, { responseType: 'blob' }).then((response) => {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })
        const urlBlob = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', 'claude-' + id + '.docx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(urlBlob)
      }).catch(() => {
        this.validarError('No se pudo descargar el Word de Claude.')
      }).finally(() => {
        this.cargar = false
      })
    },
    autorizarClaudeWord() {
      if (!this.form || !this.form.id) return
      this.autorizandoClaude = true
      this.$http.post('procesos.claude.autorizar', { id: this.form.id }).then(() => {
        this.guardarCampoProceso({ claude_autorizado: 1 })
        this.validarSuccess('Word autorizado. Ya puedes generar el PDF.')
      }).catch((error) => {
        this.validarError(this.mensajeHttp(error, 'No se pudo autorizar el Word'))
      }).finally(() => {
        this.autorizandoClaude = false
      })
    },
    generarManualPdf() {
      if (!this.form || !this.form.id) return
      this.generandoManualPdf = true
      this.$http.post('procesos.manual.pdf', { id: this.form.id }, { timeout: 120000 }).then((response) => {
        const data = response.data || {}
        const nombre = data.manual_operacion_pdf_name || ''
        this.guardarCampoProceso({ manual_operacion_pdf_name: nombre })
        this.manualOperacionExistente = nombre
        this.validarSuccess('PDF guardado como Manual de operación.')
      }).catch((error) => {
        this.validarError(this.mensajeHttp(error, 'No se pudo generar el PDF'))
      }).finally(() => {
        this.generandoManualPdf = false
      })
    },
    async descargarAudio(item) {
      if (!item.audio_name) return
      const url = this.URL_AUDIO + item.audio_name
      try {
        const response = await fetch(url)
        const blob = await response.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = item.audio_name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      } catch (err) {
        window.open(url, '_blank')
      }
    },
    definePdfDwnl() {
      if (this.pdfURL) {
        this.descargarPdfServe()
      } else if (this.pdfBase64) {
        this.descargarPdfBase64()
      } else if (this.getPdfNombre(this.form, 'archivo')) {
        this.descargarPdfProceso(this.form, 'archivo')
      }
    },
    descargarPdfServe() {
      const url = 'https://escuelakpi.club/pdf-procesos/' + this.pdfURL
      window.open(url, '_blank')
    },
    async descargarPdfBase64() {
      if (!this.pdfBase64) return
      const byteCharacters = atob(this.pdfBase64)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.pdfName || 'proceso.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    tieneAccesoAlProceso(item) {
      return item.id_usuario === this.getdatosUsuarioERPERP.iderp || [1, 334, 2345, 2574, 2230, 954].includes(this.getdatosUsuarioERPERP.iderp);
    },

    eliminar(item) {
      if (!this.tieneAccesoAlProceso(item)) return;
      this.$swal({
        title: '¿Eliminar este proceso?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargar = true;
          this.$http.delete('eliminar.proceso', { data: { id: item.id } })
            .then(() => {
              this.validarSuccess('Proceso eliminado');
              this.initialize();
            })
            .catch(error => {
              this.validarError(error.response.data.message);
            })
            .finally(() => { this.cargar = false; });
        }
      });
    },
    onPdfChange(file, tipo) {
      if (!file) return;
      if (file.type !== 'application/pdf') {
        this.validarError('Solo se permiten archivos PDF.');
        if (tipo === 'archivo') {
          this.archivoProcesoPdf = null;
        } else if (tipo === 'manual') {
          this.manualOperacionPdf = null;
        } else {
          this.diagramaProcesoPdf = null;
        }
        return;
      }
      if (tipo === 'archivo') {
        this.eliminarArchivoProcesoPdf = false;
      } else if (tipo === 'manual') {
        this.eliminarManualOperacionPdf = false;
      } else {
        this.eliminarDiagramaProcesoPdf = false;
      }
    },
    eliminarPdfProceso(tipo) {
      if (tipo === 'archivo') {
        this.archivoProcesoPdf = null;
        this.archivoProcesoExistente = '';
        if (this.form) {
          this.form.archivo_proceso_pdf_name = '';
          this.form.pdf_proceso_name = '';
          this.form.archivo_proceso_pdf = '';
          this.form.pdf_name = '';
        }
        this.eliminarArchivoProcesoPdf = true;
      } else if (tipo === 'diagrama') {
        this.diagramaProcesoPdf = null;
        this.diagramaProcesoExistente = '';
        if (this.form) {
          this.form.diagrama_proceso_pdf_name = '';
          this.form.pdf_diagrama_name = '';
          this.form.diagrama_proceso_pdf = '';
        }
        this.eliminarDiagramaProcesoPdf = true;
      } else {
        this.manualOperacionPdf = null;
        this.manualOperacionExistente = '';
        if (this.form) {
          this.form.manual_operacion_pdf_name = '';
        }
        this.eliminarManualOperacionPdf = true;
      }
      this.validarSuccess('Archivo marcado para eliminar. Guarda para aplicar cambios.');
    },
    esItemFormularioActual(item) {
      if (!item || !this.form) return false;
      if (item === this.form) return true;
      if (!item.id || !this.form.id) return false;
      return item.id === this.form.id;
    },
    getPdfNombre(item, tipo) {
      if (!item) return '';
      const usarFallbackFormulario = this.esItemFormularioActual(item);
      if (tipo === 'archivo') {
        return item.archivo_proceso_pdf_name || item.pdf_proceso_name || item.archivo_proceso_pdf || item.pdf_name || (usarFallbackFormulario ? this.archivoProcesoExistente : '') || '';
      }
      if (tipo === 'manual') {
        return item.manual_operacion_pdf_name || (usarFallbackFormulario ? this.manualOperacionExistente : '') || '';
      }
      return item.diagrama_proceso_pdf_name || item.pdf_diagrama_name || item.diagrama_proceso_pdf || (usarFallbackFormulario ? this.diagramaProcesoExistente : '') || '';
    },
    tituloPdf(tipo) {
      if (tipo === 'diagrama') return 'Diagrama del Proceso'
      if (tipo === 'manual') return 'Manual de operación'
      return 'Archivo del Proceso'
    },
    archivoPdfSeleccionado(tipo) {
      if (tipo === 'archivo') return this.archivoProcesoPdf
      if (tipo === 'manual') return this.manualOperacionPdf
      return this.diagramaProcesoPdf
    },
    getPdfUrl(item, tipo) {
      const nombre = this.getPdfNombre(item, tipo);
      if (!nombre) return '';
      return `https://escuelakpi.club/kpi/pdf-procesos/${nombre}`;
    },
    verPdf(item, tipo) {
      this.pdfPreviewTipo = tipo;
      this.pdfPreviewItem = item;
      const file = this.archivoPdfSeleccionado(tipo);
      if (file instanceof File && this.esItemFormularioActual(item)) {
        this.pdfPreviewUrl = URL.createObjectURL(file);
        this.pdfPreviewTitle = this.tituloPdf(tipo);
        this.pdfPreviewDialog = true;
        return;
      }
      const url = this.getPdfUrl(item, tipo);
      if (!url) {
        this.validarError('No hay PDF disponible para visualizar.');
        return;
      }
      this.pdfPreviewTitle = this.tituloPdf(tipo);
      this.pdfPreviewUrl = url;
      this.pdfPreviewDialog = true;
    },
    descargarPdfPreview() {
      if (!this.pdfPreviewTipo || !this.pdfPreviewItem) {
        this.validarError('No hay PDF seleccionado para descargar.');
        return;
      }
      this.descargarPdfProceso(this.pdfPreviewItem, this.pdfPreviewTipo);
    },
    cerrarPreviewPdf() {
      if (this.pdfPreviewUrl && this.pdfPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.pdfPreviewUrl);
      }
      this.pdfPreviewDialog = false;
      this.pdfPreviewUrl = '';
      this.pdfPreviewTitle = '';
      this.pdfPreviewTipo = '';
      this.pdfPreviewItem = null;
    },
    descargarPdfProceso(item, tipo) {
      const file = this.archivoPdfSeleccionado(tipo);
      if (file instanceof File && this.esItemFormularioActual(item)) {
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return;
      }
      const url = this.getPdfUrl(item, tipo);
      if (!url) {
        this.validarError('No hay PDF disponible para descargar.');
        return;
      }
      window.open(url, '_blank');
    },

    // --- MÉTODOS PARA DOCUMENTOS DE PROCESOS ---
    initializeDocumentos() {
      this.cargar = true;
      this.$http.get('get.documentos.procesos').then(response => {
        this.documentosProcesos = response.data;
        this.cargar = false;
      }).catch(error => {
        const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al obtener documentos';
        this.validarError(mensaje);
      }).finally(() => { this.cargar = false; });
    },

    crearDocumento() {
      this.formDoc = {
        id: null,
        folio: '',
        nombre_documento: '',
        archivo_nombre: '',
        estatus: 'Pendiente',
        validacion_dc: 0,
        comentarios: '',
        id_departamento: ''
      };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },

    abrirDialogDocumento(item) {
      this.formDoc = { ...item };
      this.archivoDoc = null;
      this.dialogDocumento = true;
    },

    guardarDocumento() {
      if (!this.formDoc.nombre_documento || !this.formDoc.id_departamento) {
        this.$swal({
          icon: 'warning',
          title: 'Campos incompletos',
          text: 'Nombre y Departamento son obligatorios.',
        });
        return;
      }

      if (!this.formDoc.id && !this.archivoDoc) {
        this.$swal({
          icon: 'warning',
          title: 'Archivo faltante',
          text: 'Es obligatorio seleccionar un archivo (PDF o DOC) para subir el proceso.',
        });
        return;
      }

      this.cargar = true;
      const formData = new FormData();
      Object.keys(this.formDoc).forEach(key => {
        if (this.formDoc[key] !== null && this.formDoc[key] !== undefined) {
          formData.append(key, this.formDoc[key]);
        }
      });

      if (this.archivoDoc) {
        formData.append('archivo', this.archivoDoc);
      }

      formData.append('id_usuario_subio', this.getdatosUsuarioERPERP.id_usuario);

      this.$http.post('crear.documento.proceso', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(response => {
        if (response.data.success) {
          this.validarSuccess('Documento guardado correctamente');
          this.initializeDocumentos();
          this.dialogDocumento = false;
        }
      }).catch(error => {
        const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al guardar documento';
        this.validarError(mensaje);
      }).finally(() => { this.cargar = false; });
    },

    eliminarDocumento(item) {
      this.$swal({
        title: '¿Eliminar este documento?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          this.cargar = true;
          this.$http.delete('eliminar.documento.proceso', { data: { id: item.id } })
            .then(() => {
              this.validarSuccess('Documento eliminado');
              this.initializeDocumentos();
            })
            .catch(error => {
              const mensaje = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Error al eliminar';
              this.validarError(mensaje);
            })
            .finally(() => { this.cargar = false; });
        }
      });
    },

    tieneAccesoDoc(item) {
      return item.id_usuario_subio === this.getdatosUsuarioERPERP.id_usuario ||
        this.puestos.includes(this.getdatosUsuarioERPERP.idpuesto);
    },

    descargarDocumento(item) {
      if (!item.archivo_nombre) return;
      const url = '/documentos-procesos/' + item.archivo_nombre;
      this.cargar = true;
      this.$http.get(url, { responseType: 'blob' })
        .then(response => {
          // Extraer la extensión del nombre de archivo real en el servidor
          const extension = item.archivo_nombre.split('.').pop();
          
          // Asegurar que el nombre de descarga tenga la extensión
          let nombreDescarga = item.nombre_documento || 'documento';
          if (!nombreDescarga.toLowerCase().endsWith('.' + extension.toLowerCase())) {
            nombreDescarga += '.' + extension;
          }

          // Crear el blob con el tipo que viene del servidor
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const urlBlob = window.URL.createObjectURL(blob);
          
          const link = document.createElement('a');
          link.href = urlBlob;
          link.setAttribute('download', nombreDescarga);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(urlBlob);
        })
        .catch(error => {
          console.error('Error al descargar:', error);
          this.validarError('No se pudo descargar el archivo.');
        })
        .finally(() => { this.cargar = false; });
    },
  },


}
</script>

<style>
.fase-bar {
  display: flex;
  gap: 10px;
  padding: 4px 20px 12px;
}
.fase-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #fafafa;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  outline: none;
}
.fase-item--activa {
  border-color: #5c6bc0;
  background: #eef1fb;
  box-shadow: inset 0 -3px 0 #5c6bc0;
}
.fase-num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: #e0e0e0;
  color: #424242;
  flex-shrink: 0;
}
.fase-item--activa .fase-num {
  background: #5c6bc0;
  color: #fff;
}
.fase-item--lista:not(.fase-item--activa) .fase-num {
  background: #43a047;
  color: #fff;
}
.fase-kicker {
  display: block;
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #757575;
}
.fase-nombre {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #212121;
  line-height: 1.2;
}
.proceso-stepper .v-stepper__content {
  padding: 12px 20px 8px;
}
.fase-caja {
  min-height: 112px;
  border-radius: 10px !important;
  background: #fafafa;
}
.procesos-table .v-data-table__wrapper {
  overflow-x: auto;
}

.procesos-table table {
  min-width: 1280px;
}
/* Estilos existentes para Quill */
.ql-editor ol {
  counter-reset: myCounter;
  padding-left: 2em;
  margin-bottom: 1em;
}

.ql-editor ol>li {
  list-style: none;
  counter-increment: myCounter;
  margin-bottom: 0.25em;
}

.ql-editor ol>li::before {
  content: counter(myCounter) ".- ";
  font-weight: bold;
  display: inline-block;
  width: 2em;
}

.ql-editor ul {
  list-style: none;
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.ql-editor ul>li {
  position: relative;
  padding-left: 1em;
  margin-bottom: 0.25em;
}

.ql-editor ul>li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
}

.max-scroll-text {
  max-height: 6rem;
  /* ≈ 4-5 líneas */
  overflow-y: auto;
  padding-right: 8px;
  /* evita que la barra tape texto */
}
</style>